/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toolbar_Secondary_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Secondary Toolbar" |
*
* @param {Toolbar_Secondary_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const toolbar_secondary_aria_label = /** @type {((inputs?: Toolbar_Secondary_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toolbar_Secondary_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Barre d'Outils Secondaire")
	if (locale === "de") return /** @type {LocalizedString} */ ("Sekundäre Symbolleiste")
	if (locale === "it") return /** @type {LocalizedString} */ ("Barra degli strumenti secondaria")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Дополнительная панель инструментов")
	if (locale === "es") return /** @type {LocalizedString} */ ("Barra de herramientas secundaria")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("辅助工具栏")
	if (locale === "ja") return /** @type {LocalizedString} */ ("セカンダリツールバー")
	if (locale === "hi") return /** @type {LocalizedString} */ ("द्वितीयक टूलबार")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Barra de ferramentas secundária")
	return /** @type {LocalizedString} */ ("Secondary Toolbar")
});